import React from 'react';
import './WordmarkLoader.less';
import { Wordmark } from 'app/components/logos';

interface Props {
  title: string;
}

export default function WordmarkLoader({ title }: Props) {
  return (
    <div className="wordmark-loader">
      <Wordmark className="wordmark-loader__logo-animation" />
      <span className="wordmark-loader__title">{title}</span>
    </div>
  );
}
